import { Component, OnInit, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { IGallery, IDesign } from 'rebus-models';
import { NavController } from '@ionic/angular';


@Component({
  selector: 'app-gallery-item-search-result',
  templateUrl: './gallery-item-search-result.component.html',
  styleUrls: ['./gallery-item-search-result.component.scss']
})
export class GalleryItemSearchResultComponent implements OnInit, OnChanges {

  @Input() public design: IDesign;
  @Input() public gallery: IGallery;
  @Input() public eventId: string;
  @Output() public evOnClickItem = new EventEmitter<any>();

  constructor(
    private navCtrl: NavController
  ) { }

  public ngOnInit() {
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.gallery) {
      this.gallery = changes.gallery.currentValue;
    }
  }

  public onClickGallery() {
    this.navCtrl.navigateForward([`gallery/detail/${this.gallery.id}/${this.eventId}`]);
    this.evOnClickItem.emit();
  }
}
